import { render, staticRenderFns } from "./ResponseComments.vue?vue&type=template&id=0242aa02&"
import script from "./ResponseComments.vue?vue&type=script&lang=js&"
export * from "./ResponseComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports